/* nebe-rez.js: odpočet „Rezervaci ti držíme" v bočním košíku (snippet nebe-rez-nahled).
 * Načítá se jen při zapnutém settings.nebe_rez_cart. Čas: 15 minut (od 14:59) od poslední změny množství
 * v košíku (viz resets), pak se schová.
 * Košík se překresluje přes innerHTML, proto se prvky hledají znovu každou vteřinu.
 */
(function () {
  "use strict";
  if (window.__nebeRez) return;
  window.__nebeRez = true;
  var T = "nebe_rez_t", MS = 899 * 1000; // odpočet začíná na 14:59 (David)
  function ls(k, v) {
    try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; }
  }

  // Odpočet se vrací na 14:59 při každé změně množství (David): přidání (/cart/add: tlačítka
  // motivu, PDP, sticky lišta), +/− a koš v košíku (/cart/change) a hromadná změna množství
  // (/cart/update s „updates"). Poznámka ke košíku nebo atributy (/cart/update bez „updates") ne.
  // Podmínku 15 ks přepočítá Liquid sám: košík se po každé změně překreslí přes Section Rendering.
  function resets(url, init) {
    if (/\/cart\/(add|change)/.test(url)) return true;
    if (/\/cart\/update/.test(url)) {
      var b = init && init.body;
      if (typeof b === "string") {
        try { var o = JSON.parse(b); return !!(o && o.updates); } catch (e) { return /(^|&)updates(\[|%5B|=)/.test(b); }
      }
      if (b && typeof b.has === "function") { try { return b.has("updates") || /updates\[/.test(Array.from(b.keys()).join(" ")); } catch (e) { return false; } }
    }
    return false;
  }
  var of = window.fetch;
  if (of) {
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var p = of.apply(this, arguments);
      if (resets(url, init)) p.then(function (r) {
        if (r && r.ok) ls(T, String(Date.now()));
        // 422 = víc kusů, než je skladem: Shopify srovná množství na celý sklad, ale košík se
        // nepřekreslí a nad košíkem už nic nezbývá. Odpočet hned schovat.
        else if (r && r.status === 422) { ls(T, null); tick(); }
      }).catch(function () {});
      return p;
    };
  }

  function word(n, one, few, many) { return n === 1 ? one : n >= 2 && n <= 4 ? few : many; }
  // Vteřiny se píšou vždy, i nulové („5 minut 0 vteřin"): bez nich by se text zkracoval a skákal (David).
  function text(sec, sk, bar) {
    var m = Math.floor(sec / 60), s = sec % 60, parts = [];
    if (sk) {
      if (m) parts.push(m + " " + word(m, "minútu", "minúty", "minút"));
      parts.push(s + " " + word(s, "sekundu", "sekundy", "sekúnd"));
      return (bar ? "Rezerváciu tvojho košíka držíme ešte " : "Rezerváciu ti držíme ešte ") + "\u0001" + parts.join(" ");
    }
    if (m) parts.push(m + " " + word(m, "minutu", "minuty", "minut"));
    parts.push(s + " " + word(s, "vteřinu", "vteřiny", "vteřin"));
    return (bar ? "Rezervaci tvého košíku držíme ještě " : "Rezervaci ti držíme ještě ") + "\u0001" + parts.join(" ");
  }
  // Pruh nahoře webu (sections/nebe-ship-bar.liquid): podmínka 15 ks z překresleného bočního
  // košíku ([data-nebe-rez] se vykreslí jen při splnění), bez košíku v DOM podle data-ok ze serveru.
  // Čas („9 minut 50 vteřin") se nikdy nelámal mezi minutami a vteřinami (David): text() odděluje
  // úvod a čas znakem \u0001, čas jde do <span class="nebe-rez-nw"> s white-space:nowrap.
  // Porovnává se podle textu bez značky, zapisuje se jen při změně (kvůli observeru níž).
  function put(tx, nt) {
    if (!tx) return;
    var i = nt.indexOf("\u0001");
    var plain = nt.replace("\u0001", "");
    if (tx.textContent === plain) return;
    if (i < 0) { tx.textContent = plain; return; }
    tx.textContent = nt.slice(0, i);
    var sp = document.createElement("span");
    sp.className = "nebe-rez-nw";
    sp.textContent = nt.slice(i + 1);
    tx.appendChild(sp);
  }
  function tickBar(left) {
    var bar = document.querySelector("[data-nebe-rezbar]");
    if (!bar) return;
    // Boční košík se po načtení stránky dotahuje až při prvním otevření (do té doby je prázdná
    // skořápka). Dokud v něm není vykreslený formulář košíku, platí stav ze serveru (data-state).
    var drawer = document.querySelector("#mini-cart, .cart-drawer");
    var filled = drawer && drawer.querySelector("form#cart, form.mini-cart");
    var st = bar.getAttribute("data-state"), lowAll = bar.getAttribute("data-low-all") === "1";
    if (filled) {
      var mk = drawer.querySelector("[data-nebe-rez-state]");
      st = mk ? mk.getAttribute("data-nebe-rez-state") : "none";
      lowAll = !!mk && mk.getAttribute("data-low-all") === "1";
    }
    var on = false, nt = "";
    if (st === "ok" && left > 0) {
      on = true;
      nt = text(left, bar.getAttribute("data-lang") === "sk", true);
    } else if (st === "low") {
      on = true;
      nt = bar.getAttribute(lowAll ? "data-t-low-all" : "data-t-low-some") || "";
    }
    if (on) {
      var tx = bar.querySelector("[data-nebe-rezbar-text]");
      put(tx, nt);
    }
    if (bar.hidden === on) {
      bar.hidden = !on;
      document.documentElement.classList.toggle("nebe-rez-on", on);
      if (window.NEBE_BARS && window.NEBE_BARS.measure) window.NEBE_BARS.measure();
    }
  }
  function tick() {
    var els = document.querySelectorAll("[data-nebe-rez]");
    var btns = document.querySelectorAll("[data-nebe-rez-btn]");
    var t = parseInt(ls(T) || "0", 10), left = t ? Math.ceil((t + MS - Date.now()) / 1000) : 0;
    tickBar(left);
    if (!els.length && !btns.length) return;
    // krátký řádek v tlačítku pokladny: „Rezervace ještě 9:41"
    for (var j = 0; j < btns.length; j++) {
      var bt = btns[j];
      if (left <= 0) { if (!bt.hidden) bt.hidden = true; continue; }
      var mm = Math.floor(left / 60), ss = left % 60;
      var bs = (bt.getAttribute("data-lang") === "sk" ? "Rezervácia ešte " : "Rezervace ještě ") + mm + ":" + (ss < 10 ? "0" : "") + ss;
      if (bt.textContent !== bs) bt.textContent = bs;
      if (bt.hidden) bt.hidden = false;
    }
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      // zapisovat jen změny: zápis by jinak vyvolal mutaci a observer níž by tikal v kruhu
      if (left <= 0) { if (!el.hidden) el.hidden = true; continue; }
      var tx = el.querySelector("[data-nebe-rez-text]");
      var nt = text(left, el.getAttribute("data-lang") === "sk");
      put(tx, nt);
      if (el.hidden) el.hidden = false;
    }
  }
  tick();
  setInterval(tick, 1000);
  // Košík se po každé změně překreslí (innerHTML). Prvek přichází ze serveru VIDITELNÝ s textem
  // „… 14 minut 59 vteřin", aby měl místo hned a obsah pod ním neodskočil (David). Observer běží jako
  // mikroúloha ještě před vykreslením: dopíše skutečný čas, nebo prvek po doběhnutí schová,
  // takže zákaznice nevidí ani skok, ani špatný čas. tick zapisuje jen změny, smyčka nevznikne.
  if ("MutationObserver" in window) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].addedNodes.length) { tick(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
